const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/best-dry-cleaner-in-prayagraj",
    exact: true,
    component: "BestDryCleanerInPrayagraj",
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    component: "TermsAndConditions",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "PrivacyPolicy",
  },
];

export default routes;
